// removed by extract-text-webpack-plugin
module.exports = {"QualTable":"styles__QualTable___34YUE"};


//////////////////
// WEBPACK FOOTER
// ./components/qual/Table/styles.scss
// module id = tQFm
// module chunks = 0